export default class Card {
	/**
	 * Card number or PAN
	 */
	number?: string = undefined;

	/**
	 * Card security code
	 */
	cvv2?: string = undefined;

	/**
	 * Card expire month date (MM)
	 */
	expire_month?: number = undefined;

	/**
	 * Card expire year date (YYYY)
	 */
	expire_year?: number = undefined;

	/**
	 * Cardholder name
	 */
	cardholder?: string = undefined;

	/**
	 * Get expire ISO format (YYMM)
	 *
	 * @return
	 */
	getExpireFormat(): string {
		if (!this.expire_month || !this.expire_year) {
			return '';
		}

		const year = String(this.expire_year);
		const month = ('00'+this.expire_month).slice(-2);

		return year.substr(-2) + month;
	}
}
